import { Text } from '@chakra-ui/react';

import { totalAudience } from '../../LastUpdatedPlatform/LastUpdatedPlatform.constants';
import { IHighlightSingleCard } from '../MediaPackDetailHighlightCard.types';

type Props = Omit<IHighlightSingleCard, 'title' | 'description' | 'isMulti'>;

export const MediaPackDetailHighlightCardSingleValues: React.FC<Props> = ({
  transformValue,
  value,
  lastUpdated,
  metricKey,
}) => (
  <>
    <Text fontSize={{ base: 'lg', md: '5xl' }} fontWeight={500}>
      {transformValue ? transformValue(value, 'n/a') : value}
    </Text>
    {!(metricKey && totalAudience.includes(metricKey)) && (
      <Text color={'primary.400'} fontSize="sm" fontWeight={400} marginTop={2}>
        {lastUpdated}
      </Text>
    )}
  </>
);
